//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Dialog } from 'vant';
export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      msg1:true,
      msg2:false,
      infoShow: true,
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 12, message: '密码长度在 6 到 12 个字符', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      

      this.$refs[formName].validate((valid) => {
        if (valid) {
         
          // 这里应该是登录逻辑

          
            this.$axios
              .post(this.$httpUrl + "/daren/darennewuser/login", {
                wxid: this.loginForm.username,
               
              })
              .then((res) => res.data)
              .then((res) => {
                console.log(res);
                if (res.code == 200) {
                  // sessionStorage.setItem("wxid", this.loginForm.username);
                  localStorage.setItem("wxid",this.loginForm.username)
                  // alert('登录成功！');
                  this.$router.push('/memberHome/dashbord')
                 
                  //跳转到主页
                  // this.$router.replace("/Index");
                }else if(res.code == 300){
                  localStorage.setItem("wxid", this.loginForm.username);
                  this.msg1 = false
                  this.msg2 = true
                  this.$message({
                        message: '后台管理员未审核请等待审核！',
                        type: 'success'
                    });

                  // this.$router.push('/Tupload')
                }else if(res.code == 350){
                  localStorage.setItem("wxid", this.loginForm.username);
                  this.$message({
                        message: '第一次注册，请完善资料后等待审核！',
                        type: 'success'
                    });

                  this.$router.push('/Tupload')
                }else {
                 
                  alert("校验失败，用户名或密码错误！");
                  return false;
                }
              });
         

// 

        }
      });
    },
    getcode(code) {
      this.$axios.get(this.$httpUrl + '/daren/darennewuser/getopenid?code=' + code,).then(res => res.data).then(res => {
                console.log(res)
                // alert(res.openid)
                localStorage.setItem("wxid",res.openid)
                this.loginForm.username = res.openid
                console.log(res.openid)
                this.submitForm('loginForm')
            })
            
    },
    getCode2 () { // 非静默授权，第一次有弹框
            const code = this.getUrlCode('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
            const local = window.location.href
            const appid = "wx42c6d3b85f7597bb"
            if (code == null || code === '') {
              console.log("进入微信跳转")
                window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx42c6d3b85f7597bb&redirect_uri=http://www.qlslj.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
            } else {
                this.getcode(code) //把code传给后台获取用户信息
            }
        },
    getOpenId (code) { // 通过code获取 openId等用户信息，/api/user/wechat/login 为后台接口
            let _this = this
            this.$http.post('/api/user/wechat/login', {code: code}).then((res) => {
                let datas = res.data
                if (datas.code === 0 ) {
                    console.log('成功')
                }
            }).catch((error) => {
                console.log(error)
            })
        },
    // 在methods里定义获取参数方法
    getUrlCode(name){
        // 构造一个含有目标参数的正则表达式对象
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        // 匹配目标参数
        var r = window.location.search.substr(1).match(reg);
        if(r != null){
            return unescape(r[2]);
        }else{
            return null;
        }
    }
    

  },
  created() {
    console.log("预加载") 
    this.getCode2()



  }
  
};



// WEBPACK FOOTER //
// ./src/views/login.vue